var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"inline-flex items-start gap-1 text-xs font-semibold leading-snug",class:_setup.textColorClass},[(_setup.icon)?_c('fa',{staticClass:"w-3 h-3 flex-none mt-0.5",attrs:{"icon":['fas', _setup.icon]}}):_vm._e(),_vm._v(" "),_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }